import { Pipe, PipeTransform } from '@angular/core';
import { formatarCpfCnpj } from './documento-fiscal.util';

@Pipe({
  name: 'ceiDocumentoFiscal',
  standalone: true,
})
export class DocumentoFiscalPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null || value === '' || value === '—') {
      return value ?? '';
    }
    return formatarCpfCnpj(value) || String(value);
  }
}
